import React from "react";

import "../../components/index.css";

function PrivacyPolicy() {
  return (
    <div style={{ marginLeft: "auto", marginRight: "auto", width: "90%" }}>
      <p style={{ marginTop: "1rem" }}>Last updated: 12.12.2018</p>
      <h2>Privacy Policy</h2>
      <p>
        The application Deer, hereby defined as the App, requests the following potentially sensitive data:
        <ul>
          <li>android.permission.CAMERA</li>
          <li>android.permission.READ_EXTERNAL_STORAGE</li>
          <li>android.permission.WRITE_EXTERNAL_STORAGE</li>
        </ul>
      </p>
      <p>
        This potentially sensitive data is not transmitted over the internet, and is not stored by the App. It is not handled by any system other than the device the App is installed on. It is used to provide better experience while using the App.
      </p>
      <p>
        App does not use any third party services.
      </p>
      <p>
        If you have any questions or suggestions about this Privacy Policy, do not hesitate to contact me.
      </p>
      WozAppz 2018
    </div>
  );
}

export default PrivacyPolicy;
